// extracted by mini-css-extract-plugin
export var activityContainer = "_n9-0";
export var typingIndicatorContainer = "_n9-1";
export var typingIndicatorDot = "_n9-2";
export var wave = "_n9-3";